import { render } from "./HelpGeneral.vue?vue&type=template&id=078b846e&scoped=true"
import script from "./HelpGeneral.vue?vue&type=script&lang=js"
export * from "./HelpGeneral.vue?vue&type=script&lang=js"

import "./HelpGeneral.vue?vue&type=style&index=0&id=078b846e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-078b846e"]])

export default __exports__